import 'normalize.css';
import './index.less';

import 'SITE/vendors';
import scrollFirst from 'SITE/vendors/scroll-first';

scrollFirst('programme-section2');

const sections = [];
let index = 2;
let sectionFetchDone = false
while (!sectionFetchDone) {
  const id = `programme-section${index}`;
  const section = document.getElementById(id);
  if (!section) {
    sectionFetchDone = true;
    break;
  };

  sections.push({
    id,
    section,
    animated: false
  });
  ++index;
}

window.addEventListener('scroll', (e) => {
  clearTimeout(handleScroll.timer);
  handleScroll.timer = setTimeout(handleScroll, 16);
});

handleScroll();

function handleScroll () {
  const availableSections = sections.filter(s => !s.animated);
  Array.prototype.forEach.call(availableSections, s => {
    const rect = s.section.getBoundingClientRect()
    if (rect.top < window.innerHeight * 0.9) {
      animateSection(s.id);
      s.animated = true;
    }
  });
}

function animateSection (id) {
  const banner = document.querySelector(`#${id} .programme-banner`);
  banner.style.transform = 'none';
  banner.style.opacity = '1';
  
  const upper = document.querySelector(`#${id} .programme-upper`);
  upper.style.transform = 'none';
  upper.style.opacity = '1';
}